import React from 'react';
import LiveTradingViewChart from './LiveTradingViewChart';

/** Live chart only — TradingView free advanced chart (no mock recharts). */
const PriceChart = () => <LiveTradingViewChart />;

export default PriceChart;
